import { render } from "./EditingView.vue?vue&type=template&id=ef918786"
import script from "./EditingView.vue?vue&type=script&lang=js"
export * from "./EditingView.vue?vue&type=script&lang=js"

import "./EditingView.vue?vue&type=style&index=0&id=ef918786&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__